/**
 * Bu dosya, tüm giden fetch isteklerini yakalamak ve yönetmek için kullanılır.
 */

// Gerçek interceptor fonksiyonlarını burada tanımlayabiliriz.
const interceptRequest = (args) => {
    // Giden isteği konsola yazdırabiliriz.
    console.log("Giden İstek Yakalandı:", args);
    // Örneğin, burada her isteğe bir yetkilendirme başlığı ekleyebilirsiniz.
};

const interceptResponse = async (response) => {
    // Gelen cevabı konsola yazdırabiliriz.
    console.log("Gelen Cevap Yakalandı:", response);
    // İsterseniz burada gelen cevabın içeriğini loglayabilirsiniz.
    // const data = await response.json();
    // console.log("Gelen Veri:", data);
};

const interceptError = (error) => {
    // Oluşan ağ hatalarını merkezi bir yerden yönetebiliriz.
    console.error("Ağ Hatası Yakalandı:", error);
};


/**
 * Interceptor'ı başlatan ana fonksiyon.
 * Bu fonksiyon, uygulamanın en başında SADECE BİR KEZ çağrılmalıdır.
 */
export function initApiInterceptor() {
    // console.log("API Interceptor kuruluyor...");
    const originalFetch = window.fetch;

    // İstek önizleme
    function interceptRequest(args) {
        try {
            if (args[0].includes('/api/')) {
                // console.log('Giden İstek Yakalandı:', args);
                // PUT ve POST isteklerinde veriyi de göster
                if (args[1] && (args[1].method === 'PUT' || args[1].method === 'POST')) {
                    // console.log('İstek gövdesi:', args[1].body);
                }
            }
        } catch (e) {
            console.error('İstek intercept hatası:', e.message || e);
        }
    }

    // Yanıt önizleme
    function interceptResponse(response) {
        try {
            if (response.url.includes('/api/')) {
                // console.log('Gelen Cevap Yakalandı:', response);
                // Sadece hata yanıtlarının detayını göster
                if (!response.ok) {
                    response.clone().text().then(text => {
                        try {
                            // console.error('Hata yanıt içeriği:', JSON.parse(text));
                        } catch {
                            // console.error('Hata yanıt içeriği (metin):', text);
                        }
                    });
                }
            } else if (response.url.includes('/api/location')) {
                // console.log('🏢 Backend Location API Yanıt:', response.status, response.ok ? '✅' : '❌');
                if (!response.ok) {
                    // console.error('Backend Location API Hata:', response.status, response.statusText);
                }
            }
        } catch (e) {
            console.error('Yanıt intercept hatası:', e.message || e);
        }
    }

    // Hata önizleme
    function interceptError(error, url) {
        // Location API hatalarını özel olarak yönet
        if (url && url.includes('/api/location')) {
            // console.error('🏢 Backend Location API Hatası:', error.message || error);
        } else if (url && url.includes('/api/')) {
            // console.error('❌ API Hatası:', error);
        } else {
            // console.error('🔗 Ağ Hatası:', error);
        }
    }

    window.fetch = async (...args) => {
        interceptRequest(args);
        try {
            const response = await originalFetch(...args);
            interceptResponse(response.clone()); // Orijinal cevabı bozmamak için klonluyoruz.
            return response;
        } catch (error) {
            interceptError(error, args[0]);
            throw error; // Hatayı, onu çağıran koda geri fırlatıyoruz.
        }
    };
}